// import { useState, useEffect, useCallback } from "react";
// import {
//   LayoutDashboard, CheckCircle2, Clock, Building2, AlertCircle, Lock
// } from "lucide-react";
// import DashboardLayout from "../../components/DashboardLayout";
// import { useAuth } from "../../hooks/useAuth";
// import { supabase } from "../../lib/supabaseClient";

// // ─── Constants ────────────────────────────────────────────────────────────────
// const STATUSES = [
//   {
//     key:    "on_the_way",
//     label:  "On My Way",
//     desc:   "Residents will be notified — 15 min ETA",
//     color:  "#ff9800",
//     bg:     "#fff3e0",
//     border: "#ffb74d",
//   },
//   {
//     key:    "on_site",
//     label:  "Arrived On-Site",
//     desc:   "Residents can now submit trash confirmations",
//     color:  "#1565c0",
//     bg:     "#e3f2fd",
//     border: "#90caf9",
//   },
//   {
//     key:    "completed",
//     label:  "Service Completed",
//     desc:   "Route done — summary logged automatically",
//     color:  "var(--g600)",
//     bg:     "var(--g50)",
//     border: "var(--g200)",
//   },
// ];

// const STATUS_ORDER = ["on_the_way", "on_site", "completed"];

// const NAV = [
//   { label: "Dashboard", icon: LayoutDashboard, path: "/valet/dashboard", active: true },
//   { label: "History",   icon: Clock, path: "/valet/history" },
// ];

// function getToday() {
//   return new Date().toISOString().split("T")[0];
// }

// // ─── Property Status Badge ────────────────────────────────────────────────────
// function PropStatusBadge({ status }) {
//   if (!status || status === "idle") return (
//     <span style={{
//       fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 20,
//       background: "#f5f5f5", color: "#9e9e9e", border: "1px solid #e0e0e0",
//       textTransform: "uppercase", letterSpacing: ".4px",
//     }}>Not Started</span>
//   );
//   if (status === "on_the_way") return (
//     <span style={{
//       fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 20,
//       background: "#fff3e0", color: "#e65100", border: "1px solid #ffb74d",
//       textTransform: "uppercase", letterSpacing: ".4px",
//     }}>On My Way</span>
//   );
//   if (status === "on_site") return (
//     <span style={{
//       fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 20,
//       background: "#e3f2fd", color: "#1565c0", border: "1px solid #90caf9",
//       textTransform: "uppercase", letterSpacing: ".4px",
//     }}>On Site</span>
//   );
//   if (status === "completed") return (
//     <span style={{
//       fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 20,
//       background: "var(--g50)", color: "var(--g600)", border: "1px solid var(--g200)",
//       textTransform: "uppercase", letterSpacing: ".4px",
//     }}>✓ Completed</span>
//   );
//   return null;
// }

// // ─── Status Flow ──────────────────────────────────────────────────────────────
// function StatusFlow({ currentStatus, onUpdate, updating }) {
//   const currentIdx  = STATUS_ORDER.indexOf(currentStatus);
//   const isCompleted = currentStatus === "completed";

//   if (isCompleted) return (
//     <div style={{
//       background: "var(--g50)", border: "1.5px solid var(--g200)",
//       borderRadius: 14, padding: "20px",
//       display: "flex", alignItems: "center", gap: 14,
//     }}>
//       <div style={{
//         width: 44, height: 44, borderRadius: "50%",
//         background: "var(--g600)", display: "flex", alignItems: "center", justifyContent: "center",
//         flexShrink: 0,
//       }}>
//         <CheckCircle2 size={22} color="#fff" strokeWidth={2.5} />
//       </div>
//       <div>
//         <div style={{ fontSize: 15, fontWeight: 700, color: "var(--g700)", marginBottom: 3 }}>
//           Service Completed
//         </div>
//         <div style={{ fontSize: 12.5, color: "var(--mut)" }}>
//           Today's service for this property is done. All steps logged successfully.
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//       {STATUSES.map((s, idx) => {
//         const isDone   = currentIdx > idx;
//         const isActive = currentIdx === idx;
//         const isNext   = currentIdx === -1 ? idx === 0 : currentIdx + 1 === idx;
//         const isLocked = currentIdx === -1 ? idx > 0 : idx > currentIdx + 1;

//         return (
//           <div key={s.key} style={{
//             display: "flex", gap: 14, alignItems: "center",
//             padding: "15px 18px", borderRadius: 12,
//             background: isActive ? s.bg : isDone ? "var(--g50)" : "#fff",
//             border: `1.5px solid ${isActive ? s.border : isDone ? "var(--g200)" : "var(--ln)"}`,
//             opacity: isLocked ? 0.38 : 1,
//             transition: "all .2s",
//           }}>
//             {/* Circle */}
//             <div style={{
//               width: 34, height: 34, borderRadius: "50%", flexShrink: 0,
//               background: isActive ? s.color : isDone ? "var(--g600)" : "var(--ln)",
//               display: "flex", alignItems: "center", justifyContent: "center",
//               color: isActive || isDone ? "#fff" : "var(--mut)",
//               fontSize: 13, fontWeight: 700,
//             }}>
//               {isDone ? <CheckCircle2 size={17} strokeWidth={2.5} /> : idx + 1}
//             </div>

//             {/* Text */}
//             <div style={{ flex: 1, minWidth: 0 }}>
//               <div style={{
//                 fontSize: 14, fontWeight: 600, marginBottom: 2,
//                 color: isActive ? s.color : isDone ? "var(--g700)" : "var(--mut)",
//               }}>{s.label}</div>
//               <div style={{ fontSize: 12, color: "var(--mut)", lineHeight: 1.5 }}>{s.desc}</div>
//             </div>

//             {/* Start — first step when idle */}
//             {isNext && (
//               <button onClick={() => onUpdate(s.key)} disabled={updating} style={{
//                 flexShrink: 0, padding: "8px 18px", borderRadius: 8, border: "none",
//                 background: s.color, color: "#fff", fontSize: 12, fontWeight: 700,
//                 cursor: updating ? "not-allowed" : "pointer",
//                 opacity: updating ? 0.6 : 1, whiteSpace: "nowrap",
//               }}>
//                 {updating ? "Saving…" : "Start"}
//               </button>
//             )}

//             {/* Next step — when active */}
//             {isActive && idx < STATUSES.length - 1 && (
//               <button onClick={() => onUpdate(STATUSES[idx + 1].key)} disabled={updating} style={{
//                 flexShrink: 0, padding: "8px 18px", borderRadius: 8, border: "none",
//                 background: STATUSES[idx + 1].color, color: "#fff",
//                 fontSize: 12, fontWeight: 700,
//                 cursor: updating ? "not-allowed" : "pointer",
//                 opacity: updating ? 0.6 : 1, whiteSpace: "nowrap",
//               }}>
//                 {updating ? "Saving…" : `→ ${STATUSES[idx + 1].label}`}
//               </button>
//             )}

//             {isDone && <CheckCircle2 size={18} color="var(--g600)" style={{ flexShrink: 0 }} />}
//           </div>
//         );
//       })}
//     </div>
//   );
// }

// // ─── Main Dashboard ───────────────────────────────────────────────────────────
// export default function ValetDashboard() {
//   const { profile } = useAuth();
//   const valetLabel = profile?.label || profile?.code || "Valet";
//   const today = getToday();

//   const [properties,      setProperties]      = useState([]);
//   const [propStatusMap,   setPropStatusMap]   = useState({}); // { propId: { status, recordId } }
//   const [selectedPropId,  setSelectedPropId]  = useState(null);
//   const [loadingProps,    setLoadingProps]    = useState(true);
//   const [updating,        setUpdating]        = useState(false);
//   const [error,           setError]           = useState("");

//   const selectedProp    = properties.find(p => p.id === selectedPropId) || null;
//   const selectedStatus  = propStatusMap[selectedPropId]?.status || null;
//   const selectedRecId   = propStatusMap[selectedPropId]?.recordId || null;
//   const serviceStarted  = selectedStatus && selectedStatus !== "completed";

//   // ── Fetch only valet's assigned property + today's status ──
//   const fetchAll = useCallback(async () => {
//     setLoadingProps(true);

//     // Step 1: valet code se assigned property_id fetch karo
//     const valetCodeId = profile?.codeId;
//     if (!valetCodeId) {
//       setLoadingProps(false);
//       return;
//     }

//     const { data: valetCode } = await supabase
//       .from("valet_codes")
//       .select("property_id, is_active")
//       .eq("id", valetCodeId)
//       .maybeSingle();

//     if (!valetCode || !valetCode.is_active || !valetCode.property_id) {
//       setProperties([]);
//       setLoadingProps(false);
//       return;
//     }

//     // Step 2: assigned property fetch karo
//     const { data: prop } = await supabase
//       .from("properties")
//       .select("id, name, total_units")
//       .eq("id", valetCode.property_id)
//       .eq("is_active", true)
//       .maybeSingle();

//     const propList = prop ? [prop] : [];
//     setProperties(propList);

//     // Step 3: today's status fetch karo
//     if (prop) {
//       const { data: statusRec } = await supabase
//         .from("valet_status")
//         .select("id, property_id, status")
//         .eq("property_id", prop.id)
//         .eq("service_date", today)
//         .maybeSingle();

//       if (statusRec) {
//         setPropStatusMap({
//           [prop.id]: {
//             status:   statusRec.status === "idle" ? null : statusRec.status,
//             recordId: statusRec.id,
//           }
//         });
//       }
//     }

//     setLoadingProps(false);
//   }, [today, profile?.codeId]);

//   useEffect(() => { fetchAll(); }, [fetchAll]);

//   // ── Update status ──
//   const handleStatusUpdate = async (newStatus) => {
//     if (!selectedPropId) return;
//     setUpdating(true);
//     setError("");

//     const valetCodeId = profile?.codeId || null;

//     try {
//       let newRecordId = selectedRecId;

//       if (selectedRecId) {
//         const { error: updErr } = await supabase
//           .from("valet_status")
//           .update({
//             status:        newStatus,
//             valet_code_id: valetCodeId,
//             updated_at:    new Date().toISOString(),
//           })
//           .eq("id", selectedRecId);
//         if (updErr) throw updErr;

//       } else {
//         const { data: inserted, error: insErr } = await supabase
//           .from("valet_status")
//           .insert({
//             property_id:   selectedPropId,
//             status:        newStatus,
//             valet_code_id: valetCodeId,
//             service_date:  today,
//           })
//           .select("id")
//           .single();
//         if (insErr) throw insErr;
//         newRecordId = inserted?.id || null;
//       }

//       // Update local map immediately
//       setPropStatusMap(prev => ({
//         ...prev,
//         [selectedPropId]: { status: newStatus, recordId: newRecordId },
//       }));

//       // Activity log — silent fail
//       try {
//         await supabase.from("activity_logs").insert({
//           property_id: selectedPropId,
//           action:      "valet_status_changed",
//           metadata:    { status: newStatus, code: profile?.code || null, service_date: today },
//         });
//       } catch (_) {}

//     } catch (err) {
//       console.error("Status update error:", err);
//       setError(`Failed to update: ${err.message}`);
//     }

//     setUpdating(false);
//   };

//   // ── Summary counts ──
//   const completedCount  = Object.values(propStatusMap).filter(v => v.status === "completed").length;
//   const inProgressCount = Object.values(propStatusMap).filter(v => v.status && v.status !== "completed").length;
//   const pendingCount    = properties.length - completedCount - inProgressCount;

//   return (
//     <DashboardLayout role="valet" title="Valet Operations" navItems={NAV}>

//       {/* Header */}
//       <div className="fu" style={{ marginBottom: 20 }}>
//         <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "#e65100", marginBottom: 6 }}>Valet Portal</div>
//         <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, fontWeight: 500, color: "var(--ink)", marginBottom: 4 }}>
//           Ready for today's route?
//         </h2>
//         <p style={{ fontSize: 13, color: "var(--mut)" }}>
//           Logged in as <strong style={{ color: "#e65100" }}>{valetLabel}</strong> · {today}
//         </p>
//       </div>

//       {/* Today's Summary Bar */}
//       {!loadingProps && properties.length > 0 && (
//         <div className="fu d1" style={{
//           display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10, marginBottom: 20,
//         }}>
//           {[
//             { label: "Completed",   value: completedCount,  color: "var(--g600)", bg: "var(--g50)",  border: "var(--g200)" },
//             { label: "In Progress", value: inProgressCount, color: "#ff9800",     bg: "#fff3e0",     border: "#ffb74d" },
//             { label: "Pending",     value: pendingCount,    color: "var(--mut)",  bg: "#fff",        border: "var(--ln)" },
//           ].map(({ label, value, color, bg, border }) => (
//             <div key={label} style={{
//               background: bg, border: `1.5px solid ${border}`,
//               borderRadius: 12, padding: "12px 14px", textAlign: "center",
//             }}>
//               <div style={{ fontSize: 22, fontWeight: 700, color, fontFamily: "'Outfit',sans-serif", lineHeight: 1 }}>{value}</div>
//               <div style={{ fontSize: 10, fontWeight: 700, color, textTransform: "uppercase", letterSpacing: ".5px", marginTop: 4 }}>{label}</div>
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Error */}
//       {error && (
//         <div style={{
//           display: "flex", alignItems: "center", gap: 8,
//           background: "#fef2f2", border: "1px solid #fecaca",
//           borderRadius: 10, padding: "12px 16px", marginBottom: 16,
//           fontSize: 13, color: "#dc2626",
//         }}>
//           <AlertCircle size={15} /> {error}
//         </div>
//       )}

//       {/* Property List with per-property status */}
//       <div className="fu d2">
//         <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 12 }}>
//           Today's Properties
//         </div>

//         {loadingProps ? (
//           <div style={{ textAlign: "center", padding: "32px 0", color: "var(--mut)", fontSize: 13 }}>Loading…</div>
//         ) : properties.length === 0 ? (
//           <div style={{ textAlign: "center", padding: "32px", background: "#fff", borderRadius: 12, border: "1.5px dashed var(--ln)" }}>
//             <Building2 size={28} color="var(--ln)" style={{ marginBottom: 10 }} />
//             <div style={{ fontSize: 13, color: "var(--mut)" }}>No active properties found.</div>
//           </div>
//         ) : (
//           <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 20 }}>
//             {properties.map(p => {
//               const pStatus    = propStatusMap[p.id]?.status || null;
//               const isSelected = selectedPropId === p.id;
//               const isComp     = pStatus === "completed";
//               const isLocked   = serviceStarted && !isSelected;

//               return (
//                 <button
//                   key={p.id}
//                   onClick={() => {
//                     if (isLocked) return;
//                     setSelectedPropId(prev => prev === p.id ? null : p.id);
//                     setError("");
//                   }}
//                   style={{
//                     display: "flex", alignItems: "center", gap: 12,
//                     padding: "13px 16px", borderRadius: 12,
//                     cursor: isLocked ? "not-allowed" : "pointer",
//                     background: isSelected ? (isComp ? "var(--g50)" : "#fff8f0") : "#fff",
//                     border: `1.5px solid ${isSelected ? (isComp ? "var(--g400)" : "#ffb74d") : "var(--ln)"}`,
//                     textAlign: "left",
//                     opacity: isLocked ? 0.4 : 1,
//                     transition: "all .15s",
//                   }}
//                 >
//                   <div style={{
//                     width: 36, height: 36, borderRadius: 10, flexShrink: 0,
//                     background: isComp ? "var(--g600)" : isSelected ? "#ff9800" : "var(--ln)",
//                     display: "flex", alignItems: "center", justifyContent: "center",
//                   }}>
//                     {isComp
//                       ? <CheckCircle2 size={17} color="#fff" strokeWidth={2.5} />
//                       : <Building2 size={16} color={isSelected ? "#fff" : "var(--mut)"} />
//                     }
//                   </div>

//                   <div style={{ flex: 1, minWidth: 0 }}>
//                     <div style={{ fontSize: 14, fontWeight: 700, color: "var(--ink)", marginBottom: 3 }}>{p.name}</div>
//                     <div style={{ fontSize: 12, color: "var(--mut)" }}>{p.total_units} units</div>
//                   </div>

//                   <PropStatusBadge status={pStatus} />

//                   {isLocked && <Lock size={13} color="var(--mut)" style={{ marginLeft: 4 }} />}
//                 </button>
//               );
//             })}
//           </div>
//         )}

//         {/* Active service lock warning */}
//         {serviceStarted && (
//           <div style={{
//             display: "flex", alignItems: "center", gap: 8,
//             background: "#fff3e0", border: "1px solid #ffb74d",
//             borderRadius: 10, padding: "10px 14px", marginBottom: 16,
//             fontSize: 12.5, color: "#e65100",
//           }}>
//             <Lock size={13} />
//             Other properties locked — complete current service first.
//           </div>
//         )}
//       </div>

//       {/* Status Flow — shown when property selected */}
//       {selectedProp && (
//         <div className="fu d3">
//           <div style={{
//             display: "flex", alignItems: "center", justifyContent: "space-between",
//             marginBottom: 12, flexWrap: "wrap", gap: 8,
//           }}>
//             <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--mut)" }}>
//               Service Flow — {selectedProp.name}
//             </div>
//             {!serviceStarted && (
//               <button
//                 onClick={() => { setSelectedPropId(null); setError(""); }}
//                 style={{
//                   background: "none", border: "1.5px solid var(--ln)", borderRadius: 8,
//                   padding: "4px 12px", fontSize: 12, fontWeight: 600,
//                   color: "var(--mut)", cursor: "pointer",
//                 }}
//               >
//                 ✕ Close
//               </button>
//             )}
//           </div>

//           <StatusFlow
//             currentStatus={selectedStatus}
//             onUpdate={handleStatusUpdate}
//             updating={updating}
//           />
//         </div>
//       )}

//       {/* Footer */}
//       <div className="fu d5" style={{
//         background: "var(--g50)", borderRadius: 12, border: "1px solid var(--g200)",
//         padding: "13px 18px", display: "flex", gap: 10, alignItems: "center", marginTop: 24,
//       }}>
//         <Clock size={14} color="var(--g600)" strokeWidth={1.8} />
//         <div style={{ fontSize: 12, color: "var(--ink2)" }}>
//           Code: <strong style={{ fontFamily: "monospace", color: "var(--g700)" }}>{profile?.code || "—"}</strong>
//           {"  ·  "}
//           Label: <strong style={{ color: "var(--g700)" }}>{profile?.label || "—"}</strong>
//           {"  ·  "}
//           Date: <strong style={{ color: "var(--g700)" }}>{today}</strong>
//         </div>
//       </div>

//       <style>{`@keyframes fadeUp { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }`}</style>
//     </DashboardLayout>
//   );
// }



import { useState, useEffect, useCallback } from "react";
import {
  LayoutDashboard, CheckCircle2, Clock, Building2, AlertCircle, Lock, Trash2, RefreshCw
} from "lucide-react";
import DashboardLayout from "../../components/DashboardLayout";
import { useAuth } from "../../hooks/useAuth";
import { supabase } from "../../lib/supabaseClient";

// ─── Constants ────────────────────────────────────────────────────────────────
const STATUSES = [
  {
    key:    "on_the_way",
    label:  "On My Way",
    desc:   "Residents will be notified — 15 min ETA",
    color:  "#ff9800",
    bg:     "#fff3e0",
    border: "#ffb74d",
  },
  {
    key:    "on_site",
    label:  "Arrived On-Site",
    desc:   "Residents can now submit trash confirmations",
    color:  "#1565c0",
    bg:     "#e3f2fd",
    border: "#90caf9",
  },
  {
    key:    "completed",
    label:  "Service Completed",
    desc:   "Route done — summary logged automatically",
    color:  "var(--g600)",
    bg:     "var(--g50)",
    border: "var(--g200)",
  },
];

const STATUS_ORDER = ["on_the_way", "on_site", "completed"];

const NAV = [
  { label: "Dashboard", icon: LayoutDashboard, path: "/valet/dashboard", active: true },
  { label: "History",   icon: Clock,           path: "/valet/history" },
];

function getToday() {
  return new Date().toISOString().split("T")[0];
}

function formatTime(iso) {
  return new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

// ─── Property Status Badge ────────────────────────────────────────────────────
function PropStatusBadge({ status }) {
  const configs = {
    on_the_way: { label: "On My Way", bg: "#fff3e0", color: "#e65100", border: "#ffb74d" },
    on_site:    { label: "On Site",   bg: "#e3f2fd", color: "#1565c0", border: "#90caf9" },
    completed:  { label: "✓ Done",    bg: "var(--g50)", color: "var(--g600)", border: "var(--g200)" },
  };
  const c = configs[status];
  if (!c) return (
    <span style={{ fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 20, background: "#f5f5f5", color: "#9e9e9e", border: "1px solid #e0e0e0", textTransform: "uppercase", letterSpacing: ".4px" }}>Not Started</span>
  );
  return (
    <span style={{ fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 20, background: c.bg, color: c.color, border: `1px solid ${c.border}`, textTransform: "uppercase", letterSpacing: ".4px" }}>{c.label}</span>
  );
}

// ─── Submissions Panel ────────────────────────────────────────────────────────
function SubmissionsPanel({ propertyId, today, isOnSite, onPendingChange }) {
  const [submissions, setSubmissions] = useState([]);
  const [collecting,  setCollecting]  = useState({});
  const [collectedIds, setCollectedIds] = useState(new Set());
  const [loading,     setLoading]     = useState(true);

  const fetchCollectedIds = useCallback(async () => {
    if (!propertyId) return new Set();
    const { data } = await supabase
      .from("activity_logs")
      .select("metadata")
      .eq("property_id", propertyId)
      .eq("action", "valet_collected_trash")
      .gte("created_at", `${today}T00:00:00`);
    return new Set((data || []).map(d => d.metadata?.submission_id).filter(Boolean));
  }, [propertyId, today]);

  const fetchAll = useCallback(async () => {
    if (!propertyId) return;
    const { data } = await supabase
      .from("activity_logs")
      .select("id, metadata, created_at")
      .eq("property_id", propertyId)
      .eq("action", "resident_trash_submitted")
      .gte("created_at", `${today}T00:00:00`)
      .lte("created_at", `${today}T23:59:59`)
      .order("created_at", { ascending: false });

    const subs = data || [];
    const ids  = await fetchCollectedIds();

    setSubmissions(subs);
    setCollectedIds(ids);

    // Tell parent how many are pending
    const pending = subs.filter(s => !ids.has(s.id)).length;
    onPendingChange(pending);

    setLoading(false);
  }, [propertyId, today, fetchCollectedIds, onPendingChange]);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  // Realtime — new submissions or collections
  useEffect(() => {
    if (!propertyId) return;
    const ch = supabase.channel(`valet_subs_${propertyId}`)
      .on("postgres_changes", {
        event: "INSERT", schema: "public", table: "activity_logs",
        filter: `property_id=eq.${propertyId}`,
      }, fetchAll)
      .subscribe();
    return () => supabase.removeChannel(ch);
  }, [propertyId, fetchAll]);

  const handleCollect = async (sub) => {
    setCollecting(p => ({ ...p, [sub.id]: true }));
    try {
      await supabase.from("activity_logs").insert({
        property_id: propertyId,
        action:      "valet_collected_trash",
        metadata:    {
          unit_number:   sub.metadata?.unit_number,
          service_date:  today,
          submission_id: sub.id,
        },
      });
      // Update local state immediately
      setCollectedIds(prev => {
        const next = new Set(prev);
        next.add(sub.id);
        // Update pending count for parent
        const pending = submissions.filter(s => !next.has(s.id)).length;
        onPendingChange(pending);
        return next;
      });
    } catch (err) {
      console.error("Collect error:", err);
    }
    setCollecting(p => ({ ...p, [sub.id]: false }));
  };

  const pendingCount   = submissions.filter(s => !collectedIds.has(s.id)).length;
  const collectedCount = submissions.filter(s =>  collectedIds.has(s.id)).length;

  if (loading) return (
    <div style={{ fontSize: 13, color: "var(--mut)", padding: "12px 0" }}>Loading submissions…</div>
  );

  return (
    <div style={{ marginTop: 20 }}>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10, flexWrap: "wrap", gap: 8 }}>
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--mut)" }}>
          Resident Submissions
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: "#fff3e0", color: "#e65100", border: "1px solid #ffb74d" }}>
            {pendingCount} pending
          </span>
          <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: "var(--g50)", color: "var(--g600)", border: "1px solid var(--g200)" }}>
            {collectedCount} collected
          </span>
        </div>
      </div>

      {submissions.length === 0 ? (
        <div style={{ textAlign: "center", padding: "16px", background: "#fafafa", borderRadius: 10, border: "1.5px dashed var(--ln)", fontSize: 13, color: "var(--mut)" }}>
          {isOnSite ? "No submissions yet — waiting for residents." : "Submissions will appear when service is active."}
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
          {submissions.map(sub => {
            const isCollected  = collectedIds.has(sub.id);
            const isCollecting = collecting[sub.id];
            return (
              <div key={sub.id} style={{
                display: "flex", alignItems: "center", gap: 10,
                padding: "10px 14px", borderRadius: 10,
                background: isCollected ? "var(--g50)" : "#fff",
                border: `1px solid ${isCollected ? "var(--g200)" : "var(--ln)"}`,
                transition: "all .2s",
              }}>
                <div style={{ width: 32, height: 32, borderRadius: 8, flexShrink: 0, background: isCollected ? "var(--g600)" : "#fff3e0", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  {isCollected ? <CheckCircle2 size={15} color="#fff" strokeWidth={2.5} /> : <Trash2 size={14} color="#e65100" />}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "var(--ink)" }}>
                    Unit #{sub.metadata?.unit_number ?? "—"} – Trash submitted
                  </div>
                  <div style={{ fontSize: 11, color: "var(--mut)", marginTop: 1 }}>
                    {formatTime(sub.created_at)}
                    {isCollected && <span style={{ marginLeft: 8, color: "var(--g600)", fontWeight: 600 }}>· Collected ✓</span>}
                  </div>
                </div>
                {!isCollected && (
                  <button onClick={() => handleCollect(sub)} disabled={isCollecting} style={{
                    padding: "6px 12px", borderRadius: 7, border: "none",
                    background: isCollecting ? "var(--g300)" : "var(--g600)",
                    color: "#fff", fontSize: 11, fontWeight: 700,
                    cursor: isCollecting ? "not-allowed" : "pointer",
                    flexShrink: 0, whiteSpace: "nowrap",
                  }}>
                    {isCollecting
                      ? <RefreshCw size={12} style={{ animation: "spin 1s linear infinite" }} />
                      : "Collected ✓"
                    }
                  </button>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ─── Status Flow ──────────────────────────────────────────────────────────────
function StatusFlow({ currentStatus, onUpdate, updating, pendingCount }) {
  const currentIdx  = STATUS_ORDER.indexOf(currentStatus);
  const isCompleted = currentStatus === "completed";

  if (isCompleted) return (
    <div style={{ background: "var(--g50)", border: "1.5px solid var(--g200)", borderRadius: 14, padding: "20px", display: "flex", alignItems: "center", gap: 14 }}>
      <div style={{ width: 44, height: 44, borderRadius: "50%", background: "var(--g600)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
        <CheckCircle2 size={22} color="#fff" strokeWidth={2.5} />
      </div>
      <div>
        <div style={{ fontSize: 15, fontWeight: 700, color: "var(--g700)", marginBottom: 3 }}>Service Completed</div>
        <div style={{ fontSize: 12.5, color: "var(--mut)" }}>Today's service is done. All steps logged successfully.</div>
      </div>
    </div>
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {STATUSES.map((s, idx) => {
        const isDone   = currentIdx > idx;
        const isActive = currentIdx === idx;
        const isNext   = currentIdx === -1 ? idx === 0 : currentIdx + 1 === idx;
        const isLocked = currentIdx === -1 ? idx > 0 : idx > currentIdx + 1;

        // Next step from active — is it "completed"?
        const nextStepIsComplete = isActive && idx < STATUSES.length - 1 && STATUSES[idx + 1].key === "completed";

        // Block conditions:
        // 1. "Start" button going to completed step
        const isBlockedStart = isNext && s.key === "completed" && pendingCount > 0;
        // 2. "→ Next Step" button when next step is completed
        const isBlockedNext  = nextStepIsComplete && pendingCount > 0;

        return (
          <div key={s.key} style={{
            display: "flex", gap: 14, alignItems: "center",
            padding: "15px 18px", borderRadius: 12,
            background: isActive ? s.bg : isDone ? "var(--g50)" : "#fff",
            border: `1.5px solid ${isActive ? s.border : isDone ? "var(--g200)" : "var(--ln)"}`,
            opacity: isLocked ? 0.38 : 1,
            transition: "all .2s",
          }}>
            {/* Step circle */}
            <div style={{
              width: 34, height: 34, borderRadius: "50%", flexShrink: 0,
              background: isActive ? s.color : isDone ? "var(--g600)" : "var(--ln)",
              display: "flex", alignItems: "center", justifyContent: "center",
              color: isActive || isDone ? "#fff" : "var(--mut)",
              fontSize: 13, fontWeight: 700,
            }}>
              {isDone ? <CheckCircle2 size={17} strokeWidth={2.5} /> : idx + 1}
            </div>

            {/* Label + desc */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 2, color: isActive ? s.color : isDone ? "var(--g700)" : "var(--mut)" }}>
                {s.label}
              </div>
              <div style={{ fontSize: 12, color: "var(--mut)", lineHeight: 1.5 }}>
                {/* Show blocked message on the "on_site" step when next is blocked */}
                {isBlockedNext
                  ? <span style={{ color: "#e65100", fontWeight: 600 }}>
                      {pendingCount} submission{pendingCount > 1 ? "s" : ""} pending. Please confirm collection before completing service.
                    </span>
                  : isBlockedStart
                    ? <span style={{ color: "#e65100", fontWeight: 600 }}>
                        {pendingCount} submission{pendingCount > 1 ? "s" : ""} pending. Please confirm collection before completing service.
                      </span>
                    : s.desc
                }
              </div>
            </div>

            {/* "Start" button — first step when idle */}
            {isNext && !isBlockedStart && (
              <button onClick={() => onUpdate(s.key)} disabled={updating} style={{
                flexShrink: 0, padding: "8px 18px", borderRadius: 8, border: "none",
                background: s.color, color: "#fff", fontSize: 12, fontWeight: 700,
                cursor: updating ? "not-allowed" : "pointer",
                opacity: updating ? 0.6 : 1, whiteSpace: "nowrap",
              }}>
                {updating ? "Saving…" : "Start"}
              </button>
            )}

            {/* "Start" blocked */}
            {isBlockedStart && (
              <button disabled style={{
                flexShrink: 0, padding: "8px 14px", borderRadius: 8, border: "none",
                background: "#e0e0e0", color: "#9e9e9e", fontSize: 12, fontWeight: 700,
                cursor: "not-allowed", whiteSpace: "nowrap",
                display: "flex", alignItems: "center", gap: 5,
              }}>
                <Lock size={12} /> Blocked
              </button>
            )}

            {/* "→ Next Step" button — when active, next step is NOT completed */}
            {isActive && idx < STATUSES.length - 1 && !nextStepIsComplete && (
              <button onClick={() => onUpdate(STATUSES[idx + 1].key)} disabled={updating} style={{
                flexShrink: 0, padding: "8px 18px", borderRadius: 8, border: "none",
                background: STATUSES[idx + 1].color, color: "#fff",
                fontSize: 12, fontWeight: 700,
                cursor: updating ? "not-allowed" : "pointer",
                opacity: updating ? 0.6 : 1, whiteSpace: "nowrap",
              }}>
                {updating ? "Saving…" : `→ ${STATUSES[idx + 1].label}`}
              </button>
            )}

            {/* "→ Service Completed" — blocked */}
            {isActive && nextStepIsComplete && isBlockedNext && (
              <button disabled style={{
                flexShrink: 0, padding: "8px 14px", borderRadius: 8, border: "none",
                background: "#e0e0e0", color: "#9e9e9e", fontSize: 12, fontWeight: 700,
                cursor: "not-allowed", whiteSpace: "nowrap",
                display: "flex", alignItems: "center", gap: 5,
              }}>
                <Lock size={12} /> Blocked
              </button>
            )}

            {/* "→ Service Completed" — allowed */}
            {isActive && nextStepIsComplete && !isBlockedNext && (
              <button onClick={() => onUpdate(STATUSES[idx + 1].key)} disabled={updating} style={{
                flexShrink: 0, padding: "8px 18px", borderRadius: 8, border: "none",
                background: STATUSES[idx + 1].color, color: "#fff",
                fontSize: 12, fontWeight: 700,
                cursor: updating ? "not-allowed" : "pointer",
                opacity: updating ? 0.6 : 1, whiteSpace: "nowrap",
              }}>
                {updating ? "Saving…" : `→ ${STATUSES[idx + 1].label}`}
              </button>
            )}

            {isDone && <CheckCircle2 size={18} color="var(--g600)" style={{ flexShrink: 0 }} />}
          </div>
        );
      })}
    </div>
  );
}

// ─── Main Dashboard ───────────────────────────────────────────────────────────
export default function ValetDashboard() {
  const { profile } = useAuth();
  const valetLabel  = profile?.label || profile?.code || "Valet";
  const today       = getToday();

  const [properties,     setProperties]     = useState([]);
  const [propStatusMap,  setPropStatusMap]  = useState({});
  const [selectedPropId, setSelectedPropId] = useState(null);
  const [loadingProps,   setLoadingProps]   = useState(true);
  const [updating,       setUpdating]       = useState(false);
  const [error,          setError]          = useState("");
  const [pendingCount,   setPendingCount]   = useState(0);

  const selectedProp   = properties.find(p => p.id === selectedPropId) || null;
  const selectedStatus = propStatusMap[selectedPropId]?.status || null;
  const selectedRecId  = propStatusMap[selectedPropId]?.recordId || null;
  const serviceStarted = selectedStatus && selectedStatus !== "completed";
  const isOnSite       = selectedStatus === "on_site";

  // Reset pending count when property changes
  useEffect(() => { setPendingCount(0); }, [selectedPropId]);

  // ── Fetch assigned property + today's status ──
  const fetchAll = useCallback(async () => {
    setLoadingProps(true);
    const valetCodeId = profile?.codeId;
    if (!valetCodeId) { setLoadingProps(false); return; }

    const { data: valetCode } = await supabase
      .from("valet_codes")
      .select("property_id, is_active")
      .eq("id", valetCodeId)
      .maybeSingle();

    if (!valetCode?.is_active || !valetCode?.property_id) {
      setProperties([]); setLoadingProps(false); return;
    }

    const { data: prop } = await supabase
      .from("properties")
      .select("id, name, total_units")
      .eq("id", valetCode.property_id)
      .eq("is_active", true)
      .maybeSingle();

    const propList = prop ? [prop] : [];
    setProperties(propList);

    if (prop) {
      const { data: statusRec } = await supabase
        .from("valet_status")
        .select("id, property_id, status")
        .eq("property_id", prop.id)
        .eq("service_date", today)
        .maybeSingle();

      if (statusRec) {
        setPropStatusMap({
          [prop.id]: {
            status:   statusRec.status === "idle" ? null : statusRec.status,
            recordId: statusRec.id,
          }
        });
      }
    }
    setLoadingProps(false);
  }, [today, profile?.codeId]);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  // ── Update status ──
  const handleStatusUpdate = async (newStatus) => {
    if (!selectedPropId) return;
    setUpdating(true); setError("");
    const valetCodeId = profile?.codeId || null;

    try {
      let newRecordId = selectedRecId;

      if (selectedRecId) {
        const { error: updErr } = await supabase
          .from("valet_status")
          .update({ status: newStatus, valet_code_id: valetCodeId, updated_at: new Date().toISOString() })
          .eq("id", selectedRecId);
        if (updErr) throw updErr;
      } else {
        const { data: inserted, error: insErr } = await supabase
          .from("valet_status")
          .insert({ property_id: selectedPropId, status: newStatus, valet_code_id: valetCodeId, service_date: today })
          .select("id").single();
        if (insErr) throw insErr;
        newRecordId = inserted?.id || null;
      }

      setPropStatusMap(prev => ({
        ...prev,
        [selectedPropId]: { status: newStatus, recordId: newRecordId },
      }));

      try {
        await supabase.from("activity_logs").insert({
          property_id: selectedPropId,
          action:      "valet_status_changed",
          metadata:    { status: newStatus, code: profile?.code || null, service_date: today },
        });
      } catch (_) {}

    } catch (err) {
      setError(`Failed to update: ${err.message}`);
    }
    setUpdating(false);
  };

  const completedCount   = Object.values(propStatusMap).filter(v => v.status === "completed").length;
  const inProgressCount  = Object.values(propStatusMap).filter(v => v.status && v.status !== "completed").length;
  const pendingPropCount = properties.length - completedCount - inProgressCount;

  return (
    <DashboardLayout role="valet" title="Valet Operations" navItems={NAV}>

      {/* Header */}
      <div className="fu" style={{ marginBottom: 20 }}>
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "#e65100", marginBottom: 6 }}>Valet Portal</div>
        <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, fontWeight: 500, color: "var(--ink)", marginBottom: 4 }}>
          Ready for today's route?
        </h2>
        <p style={{ fontSize: 13, color: "var(--mut)" }}>
          Logged in as <strong style={{ color: "#e65100" }}>{valetLabel}</strong> · {today}
        </p>
      </div>

      {/* Summary Bar */}
      {!loadingProps && properties.length > 0 && (
        <div className="fu d1" style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10, marginBottom: 20 }}>
          {[
            { label: "Completed",   value: completedCount,   color: "var(--g600)", bg: "var(--g50)",  border: "var(--g200)" },
            { label: "In Progress", value: inProgressCount,  color: "#ff9800",     bg: "#fff3e0",     border: "#ffb74d" },
            { label: "Pending",     value: pendingPropCount, color: "var(--mut)",  bg: "#fff",        border: "var(--ln)" },
          ].map(({ label, value, color, bg, border }) => (
            <div key={label} style={{ background: bg, border: `1.5px solid ${border}`, borderRadius: 12, padding: "12px 14px", textAlign: "center" }}>
              <div style={{ fontSize: 22, fontWeight: 700, color, fontFamily: "'Outfit',sans-serif", lineHeight: 1 }}>{value}</div>
              <div style={{ fontSize: 10, fontWeight: 700, color, textTransform: "uppercase", letterSpacing: ".5px", marginTop: 4 }}>{label}</div>
            </div>
          ))}
        </div>
      )}

      {/* Error */}
      {error && (
        <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 10, padding: "12px 16px", marginBottom: 16, fontSize: 13, color: "#dc2626" }}>
          <AlertCircle size={15} /> {error}
        </div>
      )}

      {/* Property List */}
      <div className="fu d2">
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 12 }}>
          Today's Properties
        </div>

        {loadingProps ? (
          <div style={{ textAlign: "center", padding: "32px 0", color: "var(--mut)", fontSize: 13 }}>Loading…</div>
        ) : properties.length === 0 ? (
          <div style={{ textAlign: "center", padding: "32px", background: "#fff", borderRadius: 12, border: "1.5px dashed var(--ln)" }}>
            <Building2 size={28} color="var(--ln)" style={{ marginBottom: 10 }} />
            <div style={{ fontSize: 13, color: "var(--mut)" }}>No active properties found.</div>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 20 }}>
            {properties.map(p => {
              const pStatus    = propStatusMap[p.id]?.status || null;
              const isSelected = selectedPropId === p.id;
              const isComp     = pStatus === "completed";
              const isLocked   = serviceStarted && !isSelected;

              return (
                <button key={p.id} onClick={() => {
                  if (isLocked) return;
                  setSelectedPropId(prev => prev === p.id ? null : p.id);
                  setError("");
                }} style={{
                  display: "flex", alignItems: "center", gap: 12,
                  padding: "13px 16px", borderRadius: 12,
                  cursor: isLocked ? "not-allowed" : "pointer",
                  background: isSelected ? (isComp ? "var(--g50)" : "#fff8f0") : "#fff",
                  border: `1.5px solid ${isSelected ? (isComp ? "var(--g400)" : "#ffb74d") : "var(--ln)"}`,
                  textAlign: "left", opacity: isLocked ? 0.4 : 1, transition: "all .15s",
                }}>
                  <div style={{ width: 36, height: 36, borderRadius: 10, flexShrink: 0, background: isComp ? "var(--g600)" : isSelected ? "#ff9800" : "var(--ln)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    {isComp ? <CheckCircle2 size={17} color="#fff" strokeWidth={2.5} /> : <Building2 size={16} color={isSelected ? "#fff" : "var(--mut)"} />}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 14, fontWeight: 700, color: "var(--ink)", marginBottom: 3 }}>{p.name}</div>
                    <div style={{ fontSize: 12, color: "var(--mut)" }}>{p.total_units} units</div>
                  </div>
                  <PropStatusBadge status={pStatus} />
                  {isLocked && <Lock size={13} color="var(--mut)" style={{ marginLeft: 4 }} />}
                </button>
              );
            })}
          </div>
        )}

        {serviceStarted && (
          <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#fff3e0", border: "1px solid #ffb74d", borderRadius: 10, padding: "10px 14px", marginBottom: 16, fontSize: 12.5, color: "#e65100" }}>
            <Lock size={13} />
            Other properties locked — complete current service first.
          </div>
        )}
      </div>

      {/* Status Flow + Submissions */}
      {selectedProp && (
        <div className="fu d3">
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12, flexWrap: "wrap", gap: 8 }}>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--mut)" }}>
              Service Flow — {selectedProp.name}
            </div>
            {!serviceStarted && (
              <button onClick={() => { setSelectedPropId(null); setError(""); }} style={{ background: "none", border: "1.5px solid var(--ln)", borderRadius: 8, padding: "4px 12px", fontSize: 12, fontWeight: 600, color: "var(--mut)", cursor: "pointer" }}>
                ✕ Close
              </button>
            )}
          </div>

          <StatusFlow
            currentStatus={selectedStatus}
            onUpdate={handleStatusUpdate}
            updating={updating}
            pendingCount={pendingCount}
          />

          {/* Submissions Panel */}
          {selectedStatus && selectedStatus !== "idle" && (
            <SubmissionsPanel
              propertyId={selectedPropId}
              today={today}
              isOnSite={isOnSite}
              onPendingChange={setPendingCount}
            />
          )}
        </div>
      )}

      {/* Footer */}
      <div className="fu d5" style={{ background: "var(--g50)", borderRadius: 12, border: "1px solid var(--g200)", padding: "13px 18px", display: "flex", gap: 10, alignItems: "center", marginTop: 24 }}>
        <Clock size={14} color="var(--g600)" strokeWidth={1.8} />
        <div style={{ fontSize: 12, color: "var(--ink2)" }}>
          Code: <strong style={{ fontFamily: "monospace", color: "var(--g700)" }}>{profile?.code || "—"}</strong>
          {"  ·  "}
          Label: <strong style={{ color: "var(--g700)" }}>{profile?.label || "—"}</strong>
          {"  ·  "}
          Date: <strong style={{ color: "var(--g700)" }}>{today}</strong>
        </div>
      </div>

      <style>{`
        @keyframes fadeUp { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
        @keyframes spin   { to { transform:rotate(360deg); } }
      `}</style>
    </DashboardLayout>
  );
}